const STORAGE_KEY = 'ff_demo_access_requests';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeAll(requests) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(requests));
}

export function getRequests() {
  return readAll();
}

export function getRequestByEmail(email) {
  return readAll().find(r => r.email.toLowerCase() === email.toLowerCase()) || null;
}

export function submitRequest({ name, email, company, role, reason }) {
  const requests = readAll();
  const existing = requests.find(r => r.email.toLowerCase() === email.toLowerCase());
  if (existing) {
    return existing;
  }
  const request = {
    id: `demo-req-${Date.now()}`,
    name,
    email,
    company,
    role,
    reason,
    status: 'pending',
    requestedAt: new Date().toISOString(),
    reviewedAt: null,
    reviewedBy: null,
    notes: '',
  };
  requests.push(request);
  writeAll(requests);
  return request;
}

export function updateRequestStatus(id, status, reviewerName = null, notes = '') {
  const requests = readAll();
  const idx = requests.findIndex(r => r.id === id);
  if (idx === -1) return null;
  requests[idx] = {
    ...requests[idx],
    status,
    reviewedAt: new Date().toISOString(),
    reviewedBy: reviewerName,
    notes: notes || requests[idx].notes,
  };
  writeAll(requests);
  return requests[idx];
}

export function deleteRequest(id) {
  const requests = readAll().filter(r => r.id !== id);
  writeAll(requests);
}

export function isEmailApproved(email) {
  const req = getRequestByEmail(email);
  return req?.status === 'approved';
}
